module.exports = __webpack_public_path__ + "static/img/user.834f4df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user.jpg
// module id = ZJ6t
// module chunks = 125